interface Testimonial {
  id: number;
  name: string;
  username: string;
  text: string;
  color: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Jennifer Walsh',
    username: '@jenniferw',
    text: 'Found the most amazing hidden campsite thanks to this blog! The detailed directions and tips made our first RV trip absolutely perfect.',
    color: 'bg-blue-100',
  },
  {
    id: 2,
    name: 'Marcus Thompson',
    username: '@marcust',
    text: 'As a Hudson Valley local, I thought I knew all the spots. This site proved me wrong and introduced me to incredible places I never knew existed.',
    color: 'bg-green-100',
  },
  {
    id: 3,
    name: 'Rachel Kim',
    username: '@rachelk',
    text: 'The family-friendly recommendations are spot on. Our kids had the time of their lives, and we felt safe and prepared thanks to the detailed guides.',
    color: 'bg-purple-100',
  },
  {
    id: 4,
    name: 'David Martinez',
    username: '@davidm',
    text: 'Best camping resource for the Hudson Valley region. The seasonal tips and weather advice saved our autumn camping trip from disaster!',
    color: 'bg-yellow-100',
  },
  {
    id: 5,
    name: 'Amanda Foster',
    username: '@amandaf',
    text: 'Love the honest reviews and beautiful photography. It really captures the essence of camping in this gorgeous region. Highly recommend!',
    color: 'bg-pink-100',
  },
  {
    id: 6,
    name: 'Chris Anderson',
    username: '@chrisa',
    text: 'The RV maintenance tips are invaluable. Saved me hundreds of dollars and countless headaches. This blog is a must-read for any RV owner.',
    color: 'bg-orange-100',
  },
];

const Testimonials = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <div className="inline-block px-4 py-2 bg-sage rounded-full mb-4">
            <p className="text-sm uppercase tracking-wider text-forest font-medium">CAMPER STORIES</p>
          </div>
          <h2 className="font-sans text-5xl font-extrabold text-gray-900 leading-tight">
            What Fellow Adventurers<br />
            Are Saying
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-14 h-14 ${testimonial.color} rounded-full flex items-center justify-center flex-shrink-0`}>
                  <span className="text-gray-700 font-bold text-lg">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.username}</p>
                </div>
              </div>
              
              <p className="text-gray-700 leading-relaxed">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;